/*  ========================================================================
    # Hooks - Use Posts API
    ========================================================================  */

import { useEffect, useState } from 'react';
import useTranslation from '../hooks/useTranslation';

const usePostsApi = (postType, exclude, params) => {
  const [loadingPosts, setLoadingPosts] = useState(true);
  const [posts, setPosts] = useState([]);
  const [postsCount, setPostsCount] = useState(0);
  const paramsString = new URLSearchParams();
  const __ = useTranslation();

  const getPosts = async () => {
    setLoadingPosts(true);

    let noPosts = false;

    for (const [key, value] of Object.entries(params)) {
      if (key === 'categories') {
        if (value !== '' && value.length > 0) {
          paramsString.append('categories', value);
        }
      } else if (key === 'per_page' && value === 0) {
        noPosts = true;
      } else {
        paramsString.append(key, value);
      }
    }

    if (noPosts) {
      setLoadingPosts(false);
      setPostsCount(0);
      setPosts([]);
    } else {
      try {
        const response = await fetch(
          `/wp-json/wp/v2/${postType}?${paramsString.toString()}&exclude=${exclude.toString()}`
        );

        if (response.status !== 200) {
          throw new Error(await response.text());
        }

        const posts = await response.json();
        const mappedPosts = [];

        posts.map(post => {
          let info = '';
          let link = post.link;
          let postTitle = post.title.rendered;
          const postDate = new Date(post.date);
          switch (postType) {
            case 'posts':
              info = post.categories;
              break;
            case '247grad_event': {
              const eventDate = new Date(
                post.acf.date?.substring(0, 4),
                parseInt(post.acf.date?.substring(4, 6), 10) - 1,
                post.acf.date?.substring(6, 8)
              );
              info = `${__('section-event-on', {
                date: eventDate.toLocaleDateString('de-DE', {
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric'
                })
              })}`;
              break;
            }
            case '247grad_press':
              info = __('section-press-note-on', { date: postDate.toLocaleDateString('de-DE') });
              break;
            case '247grad_resource':
              info = post.acf.info;
              break;
            case '247grad_job':
              info = post.acf.job_info;
              link = post.acf.link;
              postTitle = post.acf.job_title;
              break;
          }

          mappedPosts.push({
            id: post.id,
            permalink: link,
            image: { sizes: post.featured_image, alt: post.title.rendered },
            info,
            title: postTitle,
            excerpt: post.excerpt.rendered.replace('<p>', '').replace('</p>', ''),
            content: post.content
              ? post.content.rendered.replace('<p>', '').replace('</p>', '')
              : '',
            post: {
              post_type: postType === 'posts' ? 'post' : postType
            }
          });
        });

        setLoadingPosts(false);
        setPostsCount(parseInt(response.headers.get('X-WP-Total'), 10));
        setPosts(mappedPosts);
      } catch (error) {
        setLoadingPosts(false);
        console.log(error); // eslint-disable-line
      }
    }
  };

  useEffect(() => {
    getPosts();
  }, [params.per_page, params.page, params.categories, params.search, params.offset]);

  return { loadingPosts, posts, postsCount };
};

export default usePostsApi;
